import { StudioState } from '../../types/store';

export const handleBatchStart = (state: StudioState, action): StudioState => ({
  ...state,
  batchAction: undefined,
  runningBatches: state.runningBatches.concat([action.payload]),
});

export const handleBatchError = (state: StudioState, action): StudioState => ({
  ...state,
  batchAction: undefined,
});

export const handleBatchFinish = (state: StudioState, action): StudioState => ({
  ...state,
  runningBatches: state.runningBatches.filter(
    batch => batch.batchId !== action.payload.batchId
  ),
});

export const handleBatchLoadGalleries = (state: StudioState): StudioState => ({
  ...state,
  batchActionLoading: true,
});

export const handleBatchLoadGalleriesFailure = (
  state: StudioState
): StudioState => ({
  ...state,
  batchActionLoading: false,
});

export const handleBatchLoadGalleriesSuccess = (
  state: StudioState,
  action
): StudioState => ({
  ...state,
  ...action.payload,
  batchActionLoading: false,
});

export const handleBatchLoadTiers = (state: StudioState): StudioState => ({
  ...state,
  batchActionLoading: true,
});

export const handleBatchLoadTiersFailure = (
  state: StudioState
): StudioState => ({
  ...state,
  batchActionLoading: false,
});

export const handleBatchLoadTiersSuccess = (
  state: StudioState,
  action
): StudioState => ({
  ...state,
  ...action.payload,
  batchActionLoading: false,
});

export const handleBatchMerge = (state: StudioState): StudioState => ({
  ...state,
  batchActionLoading: true,
});

export const handleBatchMergeSuccess = (state: StudioState): StudioState => ({
  ...state,
  batchActionLoading: false,
});

export const handleBatchMergeFailure = (state: StudioState): StudioState => ({
  ...state,
  batchActionLoading: false,
});
